import { css } from '@emotion/core';


/**
 * default field set style
 * Chrome adds padding and margins to fieldsets by default
 */
export const FIELDSET_DEFAULT = css`
  padding: 0;
  margin: 0;
  border: 0 none;
`;